<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          Sitemap
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-2" v-model="filterFormModel.keyword" v-on:keydown.enter="load"
                          :placeholder="$t('keyword')" />
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-2"/>
            <button @click="load" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <import/>
                <export/>
                <button @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('sitemapInfo') }}</div>
            <div class="col-lg-2">{{ $t('description') }}</div>
            <div class="col-lg-2">{{ $t('permission') }}</div>
            <div class="col-lg-2">{{ $t('note') }}</div>
            <div class="col-lg-2">{{ $t('info') }}</div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <div>
                <b>{{ $t('title') }}: </b>{{ item.title }}
              </div>
              <div>
                <b>{{ $t('path') }}: </b>{{ item.path }}
              </div>
            </div>
            <div class="col-lg-2">
              {{ item.description }}
            </div>
            <div class="col-lg-2">
              {{ item.permission }}
            </div>
            <div class="col-lg-2">
              {{ item.note }}
            </div>
            <div class="col-lg-2">
              <div>
                <b>{{ $t('createTime') }}: </b>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}
              </div>
              <div v-if="item.updateTime">
                <b>{{ $t('updateTime') }}: </b>{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}
              </div>
            </div>
            <div class="col-lg-1">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="update(item._id)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="edit"/>&nbsp;{{ $t('edit') }}
                    </button>
                    <button @click="del(item._id)" type="button" class="btn btn-sm btn-danger mr-1" >
                      <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="m" v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <form-input :label="$t('title')" :model="formModel" :errors="formErrors" attribute="title"/>
      <form-input :label="$t('path')" :model="formModel" :errors="formErrors" attribute="path"/>
      <form-textarea :label="$t('description')" :model="formModel" :errors="formErrors" attribute="description"/>
      <form-textarea :label="$t('permission')" :model="formModel" :errors="formErrors" attribute="permission"/>
      <form-textarea :label="$t('note')" :model="formModel" :errors="formErrors" attribute="note"/>
    </b-modal>
  </main>
</template>

<script>
import List from '@/mixins/List'
import CRUD from '@/mixins/CRUD'
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import Import from "@/views/sitemap/Import.vue";
import Export from "@/views/sitemap/Export.vue";

export default {
  components: {Import, Export ,TimeRangePicker},
  mixins: [List, CRUD],
  data: function () {
    return {
      autoLoad: true,
      service: '/admin-sitemap',
      reloadBus: 'reloadSitemap',
      defaultFilterFormModel: {
        keyword: null,
      }
    }
  },
  i18n: {
    messages: {
      en: {
        title: 'Title',
        path: 'Path',
        description: 'Description',
        permission: 'Permission',
        sitemapInfo: 'Sitemap Information',
      },
      vi: {
        title: 'Tiêu đề',
        path: 'Đường dẫn',
        description: 'Mô tả',
        permission: 'Quyền hạn',
        sitemapInfo: 'Thông tin Sitemap',
      }
    }
  }
}
</script>